import { get, post, put, destroy } from './config';

const Expeditor = {
    getPartners: () =>
        get('/v1/partners'),
    getPartnerIndicators: () =>
        get('/v1/partners/indicators'),
    getPartnerHistories: (id) =>
        get(`/v1/partners/histories/${id}`),
    getPartnerLinks: () =>
        get('/v1/partners/links'),
    updatePartnerStatus: (id, state) =>
        put(`/v1/partners/${state}/${id}`),
    createPartner: (linkType, data) =>
        post(`/v1/partners/${linkType}`, data),
    getPublishedOrders: (page, limit, orderNo, cityIdFrom, cityIdTo, shippingDate, unloadingDate) =>
        get(`v1/orders/expeditor/search?status=published&page=${page}&limit=${limit}&orderNo=${orderNo}&cityIdFrom=${cityIdFrom}&cityIdTo=${cityIdTo}&shippingDate=${shippingDate}&unloadingDate=${unloadingDate}`),
    sendOrderBids: (orderId,data) =>
        post(`v1/orderbids/${orderId}`, data),
    sendComplexOrderBid: (orderId, data) =>
        post(`/v1/complexorderbids/${orderId}`, data),
    getComplexOrderBidsByExpeditor: (orderId) =>
        get(`/v1/complexorderbids/by-expeditor?orderId=${orderId}`),
    updateComplexOrderBid: (id, data) =>
        put(`/v1/complexorderbids/${id}`, data),
    deleteComplexOrderBid: (id) =>
        destroy(`/v1/complexorderbids/${id}`),
    updateOrderBid: (id, data) =>
        put(`/v1/orderbids/${id}`, data),
    updateOrderBidPrice: (orderId, data) =>
        post(`/v1/orderbids/new-price/${orderId}`, data),
    deleteOrderBid: (id) =>
        destroy(`/v1/orderbids/${id}`),
    getOrderListForExpeditor: (type, data) =>
        post(`/v1/orders/expeditor/${type}/list`, data),
    getStatusWithOrderCountsForExpeditor: (type, data) =>
        post(`/v1/orders/expeditor/${type}/count`, data),
    getOrderBidsByExpeditor: (orderId) =>
        get(`/v1/orderbids/by-expeditor?orderId=${orderId}`),
    getDriverChat: (orderId) =>
        get(`/v1/orderchat/driver/${orderId}`),
    sendDriverChatMessage: (orderId, message) =>
        post(`/v1/orderchat/driver/${orderId}`, { message }),
    searchPartners: (type) =>
        get(`/v1/partners/${type}/search`),
    getPartnerChats: (partnerId) =>
        get(`/v1/partnerchats/${partnerId}`),
    sendPartnerChatMessage: (partnerId, message) =>
        post('/v1/partnerchats', { partnerId, message }),
    getPartnerCandidates: () =>
        get('/v1/partnercandidates'),
    invitePartner: (status, partnerId) =>
        post(`/v1/partnercandidates/${status}/${partnerId}`),
    updateCandidateStatus: (id, status) =>
        put(`/v1/partnercandidates/${status}/${id}`),
    getExpeditorExportOrders: (type, data = {}) =>
        post(`/v1/export/orders/expeditor/${type}`, data, { responseType: 'blob'}),
    updateExpectedUnloadingDate: (addressId, data) =>
        put(`/v1/orders/expected-unloading-date/${addressId}`, data),
    rejectTender: (orderId) =>
        put(`/v1/orders/expeditor/reject-tender/${orderId}`),
}

export default Expeditor;
